import React, {
  useEffect, useMemo, useRef, useState,
} from 'react';
import cn from 'classnames';
import interfaceManagementIcon from '@/asserts/images/function-intro/interface-management-icon.png';
import interfaceManagementShow from '@/asserts/images/function-intro/interface-management-show.png';
import performanceImprovementIcon from '@/asserts/images/function-intro/performance-improvement-icon.png';
import performanceImprovementShow from '@/asserts/images/function-intro/performance-improvement-show.png';
import performanceImprovementShowWoa from '@/asserts/images/function-intro/performance-improvement-show-woa.png';
import automationIcon from '@/asserts/images/function-intro/automation-icon.png';
import automationShow from '@/asserts/images/function-intro/automation-show.png';
import sharingIcon from '@/asserts/images/function-intro/sharing-icon.png';
import sharingShow from '@/asserts/images/function-intro/sharing-show.png';
import { getSite, PLATFORM } from '@/common/constants/platform-constants';

import s from './index.module.less';

const conf = [
  {
    title: '集中、规范的 API 管理',
    desc: '通过图形化的便捷交互及辅助功能、一站式信息传递与共享，替代过往的手工组装数据、额外调试工具、手工校验请求及响应参数等繁琐低效的行为。',
    menuIcon: interfaceManagementIcon,
    showImg: interfaceManagementShow,
  },
  {
    title: '提升接口开发、调试及自测效率',
    desc: '通过图形化的便捷交互及辅助功能、一站式信息传递与共享，替代过往的手工组装数据、额外调试工具、手工校验请求及响应参数等繁琐低效的行为。',
    menuIcon: performanceImprovementIcon,
    showImg: getSite() === PLATFORM.STANDALONE_WOA ? performanceImprovementShowWoa : performanceImprovementShow,
  },
  {
    title: '直观、便捷的自动化测试编排',
    desc: '帮助团队成员轻松地创建、管理和执行场景用例，快捷搭建图形化的场景用例，并提供详细的测试报告和实时的测试反馈，及时发现和修复问题。',
    menuIcon: automationIcon,
    showImg: automationShow,
  },
  {
    title: '透明的接口信息共享及传递',
    desc: '规避管理成本及信息失真等问题，将 API 全生命周期中的所有活动和数据串联起来，更大程度的达到数据复用以及即时响应的目的。',
    menuIcon: sharingIcon,
    showImg: sharingShow,
  },
];

const FunctionIntro = () => {
  const [curTab, setCurTab] = useState(0);
  const timer = useRef(null);
  const curSelConf = useMemo(() => conf?.[curTab], [curTab]);

  // 设置定时器
  const handleSetTimer = () => {
    if (timer.current) return;
    timer.current = setInterval(() => {
      setCurTab(origin => (origin === conf.length - 1 ? 0 : (origin + 1)));
    }, 3000);
  };

  const stopTimer = () => {
    if (timer.current) {
      clearInterval(timer.current);
      timer.current = null;
    }
  };

  // 鼠标移入tab，停止定时器
  const handleMouseEnter = (id) => {
    setCurTab(id);
    stopTimer();
  };

  const handleMouseLeave = () => {
    handleSetTimer();
  };

  useEffect(() => {
    handleSetTimer();
    return () => {
      stopTimer();
    };
  }, []);

  return (
    <div className={s.content}>
      <div className={s.left}>
        <div className={s.outWrap}>
          {
            conf.map((item, index) => (
              <div
                key={String(index + 1)}
                className={cn(s.menuWrap, { [s.active]: curTab === index })}
                style={curTab === index ? { backgroundImage: `url(${item.menuIcon})` } : {}}
                onMouseEnter={() => handleMouseEnter(index)}
                onMouseLeave={handleMouseLeave}
              >
                <div className={s.textWrap}>
                  <div className={s.leftTitle}>{item.title}</div>
                  <div className={s.leftDesc}>{item.desc}</div>
                </div>
              </div>
            ))
          }
        </div>
      </div>
      <div className={s.right}>
        <div className={s.rightBg} />
        <div className={s.showImgWrap}>
          <img src={curSelConf.showImg} className={s.showImg} alt="" height={832} />
        </div>
      </div>
    </div>
  );
};

export default FunctionIntro;
